import { useRef, useState } from "react";
import { S, C } from "../ui";

// Canvas-based signature capture, mouse + touch. Ported from
// CustodialView's Work Orders feature (same on-site-signing pattern —
// see that repo's App.jsx) — kept deliberately dependency-free (no
// signature_pad package) since the mechanics are simple enough that
// pulling in a library wasn't worth it there either.
//
// Calls onSave(blob) with a PNG Blob when the user taps "Save Signature".
// Renders nothing until `active` is true, matching CustodialView's own
// "don't even show the pad until a name has been typed" gating, enforced
// by the caller (see WorkOrderSignBlock in the Work Orders tab).
export default function SignaturePad({ onSave, onClear }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const hasStroke = useRef(false);
  const [empty, setEmpty] = useState(true);

  const getCtx = () => canvasRef.current.getContext("2d");

  const pointFromEvent = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const point = e.touches ? e.touches[0] : e;
    return { x: point.clientX - rect.left, y: point.clientY - rect.top };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const { x, y } = pointFromEvent(e);
    const ctx = getCtx();
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const { x, y } = pointFromEvent(e);
    const ctx = getCtx();
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = C.ink;
    ctx.lineTo(x, y);
    ctx.stroke();
    if (!hasStroke.current) { hasStroke.current = true; setEmpty(false); }
  };

  const end = () => { drawing.current = false; };

  const clear = () => {
    const canvas = canvasRef.current;
    getCtx().clearRect(0, 0, canvas.width, canvas.height);
    hasStroke.current = false;
    setEmpty(true);
    onClear && onClear();
  };

  const save = () => {
    canvasRef.current.toBlob((blob) => onSave(blob), "image/png");
  };

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={520}
        height={160}
        style={{ width: "100%", height: 160, background: C.white, border: `1.5px dashed ${C.border}`, touchAction: "none", cursor: "crosshair" }}
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
      />
      <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
        <button type="button" style={{ ...S.ghostBtn, width: "auto", padding: "8px 14px" }} onClick={clear}>Clear</button>
        <button type="button" style={{ ...S.btn(), width: "auto", padding: "8px 20px" }} disabled={empty} onClick={save}>
          Save Signature
        </button>
      </div>
    </div>
  );
}
